<app-page-header
  [pageTitle]="'Detalle de Stock Vitrificado'"
  [showBreadcrumb]="true"
  [backRoute]="'/stock'"
  [backQueryParams]="{ tab: 'embriones' }"
  [backLabel]="'Stock'"
  [currentRoute]="'Embrión congelado'"
/>

<div class="mt-6">
  @if (loadingStock) {
    <app-spinner />
  } @else if (stockVitrificado) {
    <app-card
      [title]="'Datos del stock'"
      [showEditButton]="!isEditing && !isLaboratoryOrigin"
      [editTooltip]="'Editar stock'"
      (onEditClick)="toggleEdit()"
    >
    @if (isLaboratoryOrigin) {
      <div class="mb-6 rounded-lg border border-blue-light-200 bg-blue-light-50 px-4 py-3 text-sm text-blue-light-700 dark:border-blue-light-500/30 dark:bg-blue-light-500/10 dark:text-blue-light-300">
        Este stock fue generado automaticamente desde el flujo de laboratorio y se administra desde el agendamiento OPU de origen.
      </div>
    }

    @if (isEditing) {
      @if (loadingCombos) {
        <app-spinner />
      } @else {
        <app-form [formGroup]="editForm">
          <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
            <div>
              <app-label for="donante_id">
                Donante
              </app-label>
              <app-select id="donante_id" formControlName="donante_id" placeholder="Seleccione una donante" [options]="donantesOptions" searchable />
            </div>

            <div>
              <app-label for="toro_id">
                Toro
              </app-label>
              <app-select id="toro_id" formControlName="toro_id" placeholder="Seleccione un toro" [options]="torosOptions" searchable />
            </div>

            <div>
              <app-label for="raque">
                Raque
              </app-label>
              <!-- Issue #20 (2026-09-15): raque de texto libre. -->
              <app-input-field id="raque" formControlName="raque" placeholder="Ej. Raque 1" />
            </div>

            <div>
              <app-label for="fecha_opu">
                Fecha OPU
              </app-label>
              <app-input-field id="fecha_opu" type="date" formControlName="fecha_opu" />
            </div>

            <div>
              <app-label for="fecha_vit">
                Fecha Vitrificacion
              </app-label>
              <app-input-field id="fecha_vit" type="date" formControlName="fecha_vit" />
            </div>

            <div>
              <app-label for="nro_embriones">
                Cantidad de embriones
              </app-label>
              <app-input-field id="nro_embriones" type="number" min="0" formControlName="nro_embriones" />
            </div>

            <div>
              <app-label for="fecha_te">
                Fecha TE
              </app-label>
              <app-input-field id="fecha_te" type="date" formControlName="fecha_te" />
            </div>

            <div>
              <app-label for="te">
                TE (Transferidos)
              </app-label>
              <app-input-field id="te" type="number" min="0" formControlName="te" />
            </div>

            <div>
              <app-label for="descarte">
                Descarte
              </app-label>
              <app-input-field id="descarte" type="number" min="0" formControlName="descarte" />
            </div>
          </div>
        </app-form>

        <div class="flex justify-end gap-3 mt-4">
          <button
            type="button"
            (click)="cancelEdit()"
            class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            Cancelar
          </button>
          <button
            type="button"
            (click)="save()"
            [disabled]="editForm.invalid || loading"
            class="px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            @if (loading) {
              Guardando...
            } @else {
              Guardar Cambios
            }
          </button>
        </div>
      }
    } @else {
      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Cliente</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.cliente?.persona?.nombre_generico || '-' }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Donante</p>
            <p class="font-medium text-gray-800 dark:text-white">
              {{ etiquetaVaca(stockVitrificado.donante) }}
              @if (stockVitrificado.donante?.hbp && rpVaca(stockVitrificado.donante)) {
                <br><span class="text-xs text-gray-500 dark:text-gray-400">HBP: {{ stockVitrificado.donante?.hbp }}</span>
              }
            </p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Toro</p>
            <p class="font-medium text-gray-800 dark:text-white">
              {{ stockVitrificado.toro?.nombre || '-' }}
              @if (stockVitrificado.toro?.hbp) {
                <br><span class="text-xs text-gray-500 dark:text-gray-400">HBP: {{ stockVitrificado.toro?.hbp }}</span>
              }
            </p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Raque</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.raque || '-' }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Fecha OPU</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.fecha_opu | date:'dd/MM/yyyy' }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Fecha Vitrificacion</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.fecha_vit | date:'dd/MM/yyyy' }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Embriones totales</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_total }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Embriones disponibles</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_disponibles }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Embriones reservados</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_reservados }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Embriones consumidos</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_consumidos }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">TE (Transferidos)</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.te }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Descarte</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.descarte }}</p>
          </div>
          @if (stockVitrificado.fecha_te) {
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Fecha TE</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.fecha_te | date:'dd/MM/yyyy' }}</p>
            </div>
          }
        </div>
      </div>

      @if (origenLaboratorioDetalle; as origen) {
        <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
          <h3 class="mb-4 text-base font-medium text-gray-800 dark:text-white">Origen laboratorio</h3>

          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Cliente</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.cliente || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Establecimiento</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.establecimiento || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Agendamiento OPU</p>
              <p class="font-medium text-gray-800 dark:text-white">#{{ origen.lab_agendamiento_opu_id || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Donante</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.donante || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Toro</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.toro || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Tecnica FIV</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.tecnica_fiv || '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Fecha OPU</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.fecha_agendamiento_opu ? (origen.fecha_agendamiento_opu | date:'dd/MM/yyyy') : '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Fecha salida cultivo</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ origen.fecha_salida ? (origen.fecha_salida | date:'dd/MM/yyyy') : '-' }}</p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Destino</p>
              <p class="font-medium text-gray-800 dark:text-white">{{ destinoLabel(origen.destino) }}</p>
            </div>
          </div>

          @if (origen.lab_agendamiento_opu_id) {
            <div class="mt-5 flex justify-end">
              <button
                type="button"
                (click)="goToAgendamientoOpu()"
                class="px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600"
              >
                Ver agendamiento OPU
              </button>
            </div>
          }
        </div>
      }

      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
        <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
          <h3 class="text-base font-medium text-gray-800 dark:text-white">Embriones</h3>

          @if (embrionesDisponibles.length > 0) {
            <div class="flex flex-wrap items-center gap-3">
              <button
                type="button"
                (click)="toggleSeleccionarTodos()"
                class="text-sm font-medium text-brand-500 hover:text-brand-600"
              >
                @if (todosDisponiblesSeleccionados) { Quitar selección } @else { Seleccionar disponibles }
              </button>

              <!-- 2026-09-23: la transferencia se hace desde la tabla de stock, no desde el detalle.
              @if (puedeTransferir) {
                <button
                  type="button"
                  (click)="abrirTransferir()"
                  [disabled]="embrionesSeleccionados.length === 0"
                  class="px-4 py-2 text-sm font-medium text-brand-500 border border-brand-500 rounded-lg hover:bg-brand-50 disabled:opacity-50 disabled:cursor-not-allowed dark:hover:bg-brand-500/10"
                >
                  Transferir
                </button>
              }
              -->

              <button
                type="button"
                (click)="abrirRegistrarSalida()"
                [disabled]="embrionesSeleccionados.length === 0"
                class="px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Registrar salida
                @if (embrionesSeleccionados.length > 0) {
                  ({{ totalEmbrionesSeleccionados }} embrión(es))
                }
              </button>
            </div>
          }
        </div>

        @if (embrionesDisponibles.length > 0) {
          <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">
            Seleccione embriones disponibles para registrar una donación, venta o pérdida. Las salidas por transferencia se registran desde el agendamiento de transferencia.
          </p>
        }

        @if (stockVitrificado.embriones.length > 0) {
          <div class="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
            @for (embrion of stockVitrificado.embriones; track embrion.id) {
              <div
                class="rounded-lg border px-4 py-3"
                [class.border-gray-200]="!isSeleccionado(embrion)"
                [class.dark:border-gray-700]="!isSeleccionado(embrion)"
                [class.border-brand-500]="isSeleccionado(embrion)"
                [class.cursor-pointer]="embrion.estado === 'disponible'"
                [class.opacity-70]="embrion.estado !== 'disponible'"
                (click)="toggleSeleccion(embrion)"
              >
                <div class="flex items-start justify-between gap-2">
                  <p class="font-medium text-gray-800 dark:text-white">Pajuela #{{ embrion.orden }}</p>
                  @if (embrion.estado === 'disponible') {
                    <input
                      type="checkbox"
                      class="mt-1 h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
                      [checked]="isSeleccionado(embrion)"
                      (click)="$event.stopPropagation()"
                      (change)="toggleSeleccion(embrion)"
                    />
                  }
                </div>

                <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  {{ embrion.nro_embriones }} embrión(es)
                </p>

                <div class="mt-2 flex items-center gap-2">
                  @if (embrion.ops_punto) {
                    <span class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                      @if (embrion.ops_color?.hex) {
                        <span class="h-2.5 w-2.5 rounded-full border border-gray-300 dark:border-gray-600" [style.background-color]="embrion.ops_color?.hex"></span>
                      }
                      OPS {{ embrion.ops_punto.codigo }} {{ embrion.ops_color?.nombre?.toLowerCase() }}
                    </span>
                  } @else {
                    <span class="text-xs text-gray-400 dark:text-gray-500">Sin OPS cargado</span>
                  }

                  @if (puedeEditarOps(embrion)) {
                    <button
                      type="button"
                      class="text-xs text-brand-600 hover:underline dark:text-brand-400"
                      (click)="editarOpsPajuela(embrion, $event)"
                    >
                      {{ embrion.ops_punto ? 'Cambiar OPS' : 'Cargar OPS' }}
                    </button>
                  }
                </div>
                <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
                  Estado:
                  @switch (embrion.estado) {
                    @case ('disponible') { Disponible }
                    @case ('reservada') { Reservada }
                    @case ('consumida') { {{ embrion.motivo_salida_label || 'Consumida' }} }
                  }
                </p>
                @if (embrion.fecha_consumida) {
                  <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    Salida: {{ embrion.fecha_consumida | date:'dd/MM/yyyy' }} @if (embrion.hora_consumida) { - {{ embrion.hora_consumida }} hs }
                  </p>
                }
              </div>
            }
          </div>
        } @else {
          <p class="text-sm text-gray-500 dark:text-gray-400">Este stock todavia no tiene embriones generados.</p>
        }
      </div>

      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6">
        <h3 class="mb-4 text-base font-medium text-gray-800 dark:text-white">Movimientos de salida</h3>

        <div class="mb-4 grid grid-cols-2 gap-4 md:grid-cols-4">
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Transferidos</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_por_motivo_salida['T'] || 0 }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Donados</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_por_motivo_salida['D'] || 0 }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Vendidos</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_por_motivo_salida['V'] || 0 }}</p>
          </div>
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Perdidos</p>
            <p class="font-medium text-gray-800 dark:text-white">{{ stockVitrificado.embriones_por_motivo_salida['P'] || 0 }}</p>
          </div>
        </div>

        @if (salidas.length > 0) {
          <div class="space-y-3">
            @for (salida of salidas; track salida.id) {
              <div class="rounded-lg border border-gray-200 px-4 py-3 dark:border-gray-700">
                <div class="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <div class="flex items-center gap-2">
                      <app-badge [color]="salidaBadgeColor(salida)" size="sm">{{ salida.motivo_label }}</app-badge>
                      <span class="text-sm font-medium text-gray-800 dark:text-white">
                        Pajuela #{{ salida.pajuela_orden }} · {{ salida.nro_embriones }} embrión(es)
                      </span>
                    </div>

                    <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                      {{ salida.fecha | date:'dd/MM/yyyy' }}
                      @if (salida.hora) { - {{ salida.hora }} hs }
                      @if (salida.usuario) { · {{ salida.usuario }} }
                    </p>

                    @if (salida.cliente_destino) {
                      <p class="mt-1 text-sm text-gray-600 dark:text-gray-300">Destino: {{ salida.cliente_destino }}</p>
                    }

                    @if (salida.monto_unitario !== null) {
                      <p class="mt-1 text-sm text-gray-600 dark:text-gray-300">
                        Monto: {{ salida.monto_total | number:'1.0-2' }} {{ salida.moneda }}
                        <span class="text-xs text-gray-500 dark:text-gray-400">
                          ({{ salida.nro_embriones }} × {{ salida.monto_unitario | number:'1.0-2' }})
                        </span>
                      </p>
                    }

                    @if (salida.observacion) {
                      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ salida.observacion }}</p>
                    }
                  </div>

                  @if (salida.permite_anulacion_manual) {
                    <button
                      type="button"
                      (click)="anularSalida(salida)"
                      [disabled]="anulandoSalidaId === salida.id"
                      class="px-3 py-1.5 text-xs font-medium text-error-600 border border-error-200 rounded-lg hover:bg-error-50 disabled:opacity-50 dark:border-error-500/30 dark:hover:bg-error-500/10"
                    >
                      @if (anulandoSalidaId === salida.id) { Anulando... } @else { Anular }
                    </button>
                  } @else {
                    <span class="text-xs text-gray-500 dark:text-gray-400">Se revierte desde la transferencia</span>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="text-sm text-gray-500 dark:text-gray-400">Este stock todavia no registra salidas.</p>
        }
      </div>

      <div class="flex justify-end mt-6">
        <button
          (click)="close()"
          class="px-6 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Volver al stock
        </button>
      </div>
    }
    </app-card>
  }
</div>
